const assets = {
  images: {
    logoDark: require("./images/logo-dark.png"),
    appIcon: require("./images/favicon.png"),
  },
  colors: {
    primary: "#42a5f5",
    secondary: "#ba68c8",
  },
};

export default assets;
